"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeClassNameComponent = makeClassNameComponent;
exports.nameHoc = nameHoc;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../classify"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/** Extract the actual ref instance type from a JSX element/component type */

/** Public props for generated components: original props (no ref) + optional className */

/** Utility: set displayName on a component */
function nameComponent(component, name) {
  component.displayName = name;
  return component;
}

/** HOC display name helper: sets Wrapper.displayName = `${hocName}(WrappedName)` */
function nameHoc(WrapperComponent, WrappedComponent, hocName) {
  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WrapperComponent.displayName = `${hocName}(${wrappedComponentName})`;
  return WrapperComponent;
}

/** Public alias for “className-merging” components */

/**
 * Factory: builds a component for a given intrinsic tag or component type
 * that merges `className` with a base class and forwards its ref.
 */
function makeClassNameComponent(baseClassName, ComponentType, name) {
  const Comp = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      className,
      ...props
    } = _ref;
    return /*#__PURE__*/React.createElement(ComponentType ?? 'div', {
      ...props,
      ref,
      className: (0, _classify.default)(baseClassName, className)
    });
  });
  nameComponent(Comp, `CNC(${name || ComponentType || 'div'})`);
  // Bridge Flow.AbstractComponent signature
  return Comp;
}